/**
 * OIDC configuration for Cognito authentication.
 * WHY: Single source of truth for auth provider settings.
 */
import { WebStorageStateStore } from 'oidc-client-ts';

const getBaseUrl = (): string => window.location.origin;

export const oidcConfig = {
  authority:
    import.meta.env.VITE_COGNITO_AUTHORITY ||
    'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_tQS5gAqFA',
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID || '7gv9jnh9ar7ok799lpsd145633',
  redirect_uri: `${getBaseUrl()}/callback`,
  post_logout_redirect_uri: `${getBaseUrl()}/`,
  response_type: 'code',
  scope: 'openid', //profile email
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: false,
  silent_redirect_uri: `${getBaseUrl()}/silent-callback`,
  loadUserInfo: false,
  monitorSession: false,
};

export const clearAuthState = (): void => {
  localStorage.clear();
  sessionStorage.clear();
  setTimeout(() => window.location.reload(), 100);
};
